import React from "react";
import AppTheme from "../../../../service/app_config/AppTheme";
import { IconNormal } from "../../../../widget/common/ui/Icon";
import { NoticesListContextImport } from "../../../../provider/notices/notices_list/NoticesListContextProvider";

const NoticesDetailActions = () => {
  const { handleClickDeleteConfirm } = NoticesListContextImport();

  return (
    <>
      <IconNormal
        name="delete2"
        color={AppTheme.themeFont}
        handleClick={handleClickDeleteConfirm}
      />
    </>
  );
};

export default NoticesDetailActions;
